import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./routes/Home";
import BookingPage from "./routes/Booking";
import DashboardPage from "./routes/Dashboard";
import ClientsPage from "./routes/Clients";
import FinancePage from "./routes/Finance";
import AdminPage from "./routes/Admin";
import ServicesPage from "./routes/Services";
import LocationsPage from "./routes/Locations";
import SalaryPage from "./routes/Salary";
import UsersPage from "./routes/Users";
import SMSLoginPage from "./routes/SMSLogin";
import BookingJournalPage from "./routes/BookingJournal";
import MyPhotosPage from "./routes/MyPhotos";

// Проверка авторизации
const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

// Получение роли пользователя
const getUserRole = () => {
  return localStorage.getItem("user_role") || "client";
};

// Защищенный маршрут с проверкой роли
interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles = [] }) => {
  const authenticated = isAuthenticated();
  const userRole = getUserRole();
  
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    // Перенаправляем в зависимости от роли
    switch (userRole) {
      case "admin":
        return <Navigate to="/" replace />;
      case "master":
        return <Navigate to="/" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }
  
  return <>{children}</>;
};

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={
          <ProtectedRoute allowedRoles={["admin", "master", "client"]}>
            <HomePage />
          </ProtectedRoute>
        } />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/clients" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ClientsPage />
          </ProtectedRoute>
        } />
        <Route path="/finance" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <FinancePage />
          </ProtectedRoute>
        } />
        <Route path="/services" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ServicesPage />
          </ProtectedRoute>
        } />
        <Route path="/salary" element={
          <ProtectedRoute allowedRoles={["admin", "master"]}>
            <SalaryPage />
          </ProtectedRoute>
        } />
        <Route path="/bookings" element={
          <ProtectedRoute allowedRoles={["admin", "master"]}>
            <BookingJournalPage />
          </ProtectedRoute>
        } />
        <Route path="/users" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <UsersPage />
          </ProtectedRoute>
        } />
        <Route path="/locations" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <LocationsPage />
          </ProtectedRoute>
        } />
        <Route path="/login" element={
          isAuthenticated() ? <Navigate to="/" replace /> : <SMSLoginPage />
        } />
        <Route path="/my-photos" element={
          <ProtectedRoute allowedRoles={["admin", "master", "client"]}>
            <MyPhotosPage />
          </ProtectedRoute>
        } />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminPage />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </>
  );
}

export default App;
